// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';

// Services

// Components
import { DateInput, TextInput, MoneyInput } from 'components/forms/form-elements';
import { Form } from 'components/forms/form-structure';

// Helpers
import requiredValidation from 'utils/required-validation';
import { handleServerError } from 'utils/form-utils';

// Constants

// Component
class BillingForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    resetOnSubmit: PropTypes.bool,
    onSubmit: PropTypes.func,
    reset: PropTypes.func
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(values) {
    const { onSubmit, resetOnSubmit, reset } = this.props;

    return Promise.resolve(onSubmit(values))
      .then(() => {
        if (resetOnSubmit) reset();
      });
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <Form preventAutoFocus onSubmit={handleSubmit(this.onSubmit)} {..._.pick(this.props, ['submitting', 'error', 'submitFailed'])}>
        <Field component={DateInput} name="releaseDate" label="Release Date" />
        <Field component={TextInput} name="description" label="Description" />
        <Field component={MoneyInput} elementClasses="w-100" name="amount" label="Amount" />
      </Form>
    );
  }
}

export default reduxForm({
  form: 'billing-form',
  validate: (values) => {
    const errors = {};
    const required = requiredValidation(['amount', 'date', 'description'], values);

    const allErrors = _.assign(errors, required);

    return allErrors;
  },
  onSubmitFail: handleServerError
})(BillingForm);



// WEBPACK FOOTER //
// ./app/components/models/agreement/billing-form.js